/**
 * The URL state of `/test-cases/result` — the Matrix (hub §4.2).
 *
 * `page` is the Batch Test whose Matrix is shown, `tc` the row whose TC
 * panel is open. The three filters narrow **which pages can be picked**,
 * never the columns of the one shown (artifact) — a column is a run that
 * happened, and hiding it would make the page look like it ran less.
 *
 * With no `page` the screen picks one and leaves the address alone: a
 * default is not a choice, so it is not written into history. With only
 * `tc` it picks the newest page that holds that TC — how All Test Cases'
 * "Test Result 에서 보기" lands on the right Matrix.
 *
 * Normalization, not validation: an unknown value falls back to "전체".
 */

export type ResultDays = "" | "7" | "14";

export type TestResultSearch = {
  page: string | null;
  tc: string | null;
  /** A model id; "" = every model. */
  model: string;
  /** A git ref, "deployment" for 배포본, or "" = every code. */
  code: string;
  days: ResultDays;
};

export const TEST_RESULT_DEFAULT_SEARCH: TestResultSearch = {
  page: null,
  tc: null,
  model: "",
  code: "",
  days: "",
};

export const TEST_RESULT_ROUTE = "/test-cases/result" as const;

export const DAYS_OPTIONS: { value: ResultDays; label: string }[] = [
  { value: "", label: "기간 전체" },
  { value: "7", label: "최근 7 일" },
  { value: "14", label: "최근 14 일" },
];

function asText(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed || null;
}

export function parseTestResultSearch(raw: Record<string, unknown>): TestResultSearch {
  const days = String(raw.days ?? "");
  return {
    page: asText(raw.page),
    tc: asText(raw.tc),
    model: asText(raw.model) ?? "",
    code: asText(raw.code) ?? "",
    days: days === "7" || days === "14" ? days : "",
  };
}

export function filtersActive(search: TestResultSearch): boolean {
  return search.model !== "" || search.code !== "" || search.days !== "";
}
